export default __webpack_public_path__ + "static/media/Carousel2.4ce5c9ec.png";